package editor.ui

import kotlinx.html.*
import org.w3c.dom.HTMLElement
import util.InstructionsUI

object EditorInstructions {
    /**
     * Adds the FAB and the instructions element as a child of the given [parent].
     */
    fun addHtmlTo(parent: TagConsumer<HTMLElement>) {
        InstructionsUI.addInstructionsHtmlTo(parent) {
            h2 { +"Navigation" }
            ul {
                li { +"Orbit: Linke Maustaste" }
                li { +"Verschieben (Pan): Rechte Maustaste oder Linke Maustaste + Strg/Shift" }
                li { +"Zoom: Scrollen" }
            }

            h2 { +"Bausteine platzieren" }
            p {
                +"""
                    Wähle rechts einen der Bausteine aus. Platziere dann mit folgendem Prozess den Baustein relativ zu einem
                    anderen Baustein im Modell:
                """
            }
            ol {
                li {
                    +"Klicke auf die gewünschte Anbau-Fläche im Modell und halte die linke Maustaste gedrückt."
                }
                li {
                    +"""
                        Ziehe die Maus in die Richtung, in die der Baustein zeigen soll, und um die genaue Position festzulegen.
                        Gleichzeitig kann durch Drücken von Tasten die Platzierung weiter angepasst werden (siehe unten).
                    """
                }
                li {
                    +"Lasse die Maustaste los, um die Platzierung abzuschließen, sobald die gewünschte Position angezeigt wird."
                }
            }

            h2 {
                +"Platzierung anpassen"
            }
            ul {
                li {
                    +"Genauere Abstufungen/feineres Einrasten: Halte die Shift-Taste gedrückt."
                }
                li {
                    +"Baustein-Ausrichtung ändern (bei den Timber Bricks und der Achse): Halte die Strg-Taste gedrückt."
                }
                li {
                    +"Rotation: Mit dem Mausrad / scrollen. Feinere Rotation mit der Shift-Taste."
                }
            }

            h2 {
                +"Import/Export"
            }
            p { +"Zum Speichern eines Modells als JSON-Datei, klicke oben rechts auf \"Speichern\" > \"JSON-Datei\"." }
            p { +"Um eine gespeicherte JSON-Datei zu laden, ziehe sie mit Drag and Drop hier in den Editor oder klicke auf \"Laden\" > \"JSON\"." }
        }
    }
}